import React, { Component } from 'react';
import { Button } from '@material-ui/core';

const styles = {
    btn: {
        margin: '0.25rem 0.25rem 2rem 1rem'
    }
}

export default class CreateInvoice extends Component {
    constructor(props) {
        super(props);    
        this.state =  { 
            invoice : { ...this.props.initialState},
            buttonDisabled : false
        };
    }

    handleChange = (event, propToUpdate, propValue) => {
        this.setState( { invoice : { ...this.state.invoice,
            [propToUpdate || event.target.id] : propValue || event.target.value,
        }});
    };

    render() {
        const InvoiceForm = this.props.form;
        return (
            <div className='create-invoice'>
                <InvoiceForm {...this.state.invoice} handleChange={(event, propToUpdate, propValue) => this.handleChange(event, propToUpdate, propValue)}/>
                {this.toolbar()}
            </div>
        )
    }

    handleGenerateClick() {
        this.setState({buttonDisabled : true}, async () => {
            await this.props.handleGenerateClick(this.state.invoice);
        })
       
    }

    toolbar() {

        const changed = JSON.stringify(this.state.invoice) !== JSON.stringify(this.props.initialState);
        return (
            <div className="toolbar">
                <Button 
                    className='invoice-button'
                    variant="outlined"
                    style={styles.btn}
                    color="primary"
                    onClick={() => { this.setState( this.props.initialState )}}>Clear</Button>  
                <Button
                    className='invoice-button generate'
                    variant='contained'
                    color="primary"
                    disabled={!changed || this.state.buttonDisabled}
                    style={styles.btn}
                    onClick={() => this.handleGenerateClick()}>Create Invoice</Button>
                                  
            </div>
        )
    }
}
